export default "__VITE_ASSET____b6VZD2__"